(function () {
  var currentScript = document.currentScript;
  var sectionId = currentScript ? currentScript.dataset.sectionId : '';

  document.addEventListener('DOMContentLoaded', function () {
    var variantSelectsEl = document.querySelector('variant-selects[data-section="' + sectionId + '"]');
    var variantsDataScript = variantSelectsEl && variantSelectsEl.querySelector('script[type="application/json"]');
    if (!variantsDataScript) return;

    var variants = JSON.parse(variantsDataScript.textContent);
    if (!Array.isArray(variants)) return;
    var colorPosition = variantSelectsEl?.dataset.colorOptionPosition || '1';
    var sizePosition = variantSelectsEl?.dataset.sizeOptionPosition || '2';

    function getVariantOptionValue(variant, position) {
      if (position === '1') return variant.option1;
      if (position === '2') return variant.option2;
      return variant.option3;
    }

    // 2. Função para atualizar tamanhos indisponíveis
    function updateUnavailableSizes(selectedColor) {
      var sizeInputs = document.querySelectorAll('[data-option-position="' + sizePosition + '"] input[type="radio"], [data-option-position="' + sizePosition + '"] input[type="checkbox"]');
      if (!sizeInputs.length) return;

      sizeInputs.forEach(function(input) {
        var sizeValue = input.value;
        var isAvailable = variants.some(function(variant) {
          return getVariantOptionValue(variant, colorPosition) === selectedColor
            && getVariantOptionValue(variant, sizePosition) === sizeValue
            && variant.available;
        });
        var label = input.nextElementSibling;
        if (label) {
          if (!isAvailable) {
            label.classList.add('unavailable');
          } else {
            label.classList.remove('unavailable');
          }
        }
      });
    }

    // 3. Detecta cor selecionada
    function getSelectedColor() {
      var colorInput = document.querySelector('[data-option-position="' + colorPosition + '"] input[type="radio"]:checked, [data-option-position="' + colorPosition + '"] input[type="checkbox"]:checked');
      return colorInput ? colorInput.value : null;
    }

    // 4. Atualiza ao carregar a página
    var selectedColor = getSelectedColor();
    if (selectedColor) {
      updateUnavailableSizes(selectedColor);
    }

    // 5. Atualiza ao trocar de cor
    var colorInputs = document.querySelectorAll('[data-option-position="' + colorPosition + '"] input[type="radio"], [data-option-position="' + colorPosition + '"] input[type="checkbox"]');
    colorInputs.forEach(function(input) {
      input.addEventListener('change', function() {
        updateUnavailableSizes(input.value);
      });
    });

    // 6. Se nenhuma cor está selecionada, seleciona a primeira disponível
    if (!selectedColor && colorInputs.length) {
      colorInputs[0].checked = true;
      updateUnavailableSizes(colorInputs[0].value);
    }
  });

  let productSwiper = null;
  const desktopGallerySelector = '.swiper-product-images--' + sectionId;
  const DESKTOP_GALLERY_MIN_WIDTH = 1024;
  let lastGalleryLayoutWidth = window.innerWidth;

  function isDesktopGalleryLayout() {
    return window.innerWidth >= DESKTOP_GALLERY_MIN_WIDTH;
  }

  function getDesktopProductGallery() {
    return document.querySelector(desktopGallerySelector);
  }

  function updateProductImageSkeletons() {
    const gallery = getDesktopProductGallery();
    if (!gallery) return;

    const slides = Array.from(gallery.querySelectorAll('.swiper-wrapper > .swiper-slide'));
    const imageSlides = slides.filter(function(slide) {
      return slide.querySelector('.product__media img');
    }).slice(0, 1);

    imageSlides.forEach(function(slide) {
      const media = slide.querySelector('.product__media');
      const image = slide.querySelector('.product__media img');
      if (!media || !image) return;

      const markLoaded = function() {
        media.classList.add('product__media--image-loaded');
      };

      if (image.complete && image.naturalWidth > 0) {
        markLoaded();
        return;
      }

      media.classList.remove('product__media--image-loaded');
      image.addEventListener('load', markLoaded, { once: true });
      image.addEventListener('error', markLoaded, { once: true });
    });
  }

  function whenFirstGalleryImageReady(gallery, callback) {
    const firstSlide = gallery.querySelector('.swiper-wrapper > .swiper-slide');
    if (!firstSlide) {
      callback();
      return;
    }

    const images = Array.from(firstSlide.querySelectorAll('img'));
    images.forEach(function(image) {
      image.loading = 'eager';
      image.fetchPriority = 'high';
    });

    const pendingImages = images.filter(function(image) {
      return !image.complete;
    });

    if (!pendingImages.length) {
      callback();
      return;
    }

    let loadedCount = 0;

    pendingImages.forEach(function(image) {
      const onDone = function() {
        loadedCount += 1;
        if (loadedCount === pendingImages.length) {
          callback();
        }
      };

      image.addEventListener('load', onDone, { once: true });
      image.addEventListener('error', onDone, { once: true });
    });
  }

  function updateDesktopGalleryHeight() {
    const gallery = getDesktopProductGallery();
    if (!gallery) return;

    if (window.innerWidth < DESKTOP_GALLERY_MIN_WIDTH) {
      gallery.style.removeProperty('--gallery-window-height');
      gallery.style.height = '';
      return;
    }

    const slides = gallery.querySelectorAll('.swiper-wrapper > .swiper-slide');
    if (!slides.length) return;

    gallery.style.removeProperty('--gallery-window-height');
    gallery.style.height = 'auto';

    const firstSlideHeight = slides[0].getBoundingClientRect().height;
    if (!firstSlideHeight) return;

    const heightValue = `${Math.round(firstSlideHeight)}px`;
    gallery.style.setProperty('--gallery-window-height', heightValue);
    gallery.style.height = heightValue;
  }

  function scheduleDesktopGalleryHeightUpdate() {
    const gallery = getDesktopProductGallery();
    if (!gallery || window.innerWidth < DESKTOP_GALLERY_MIN_WIDTH) return;

    updateProductImageSkeletons();
    window.requestAnimationFrame(updateDesktopGalleryHeight);

    whenFirstGalleryImageReady(gallery, function() {
      window.requestAnimationFrame(updateDesktopGalleryHeight);
    });
  }

  function initSwiper(attempts = 0) {
    const maxAttempts = 50;
    const swiperSelector = '.swiper-product-images--' + sectionId;

    if (typeof Swiper === 'undefined') {
      if (attempts < maxAttempts) {
        setTimeout(() => initSwiper(attempts + 1), 100);
        return;
      } else {
        console.error('Swiper library failed to load');
        return;
      }
    }

    const swiperElement = document.querySelector(swiperSelector);
    if (!swiperElement) {
      console.warn('Swiper element not found');
      return;
    }

    const savedActiveIndex = productSwiper ? productSwiper.activeIndex : 0;

    if (productSwiper) {
      productSwiper.destroy(true, true);
      productSwiper = null;
      window.productSwiper = null;
    }

    const swiperWrapper = swiperElement.querySelector('.swiper-wrapper');

    if (isDesktopGalleryLayout()) {
      if (swiperWrapper) {
        swiperWrapper.style.transform = '';
      }
      window.productSwiper = null;
      scheduleDesktopGalleryHeightUpdate();
      return;
    }

    if (swiperWrapper) {
      swiperWrapper.style.transform = '';
    }

    const gallery = document.querySelector(swiperSelector);
    if (gallery) {
      gallery.style.removeProperty('--gallery-window-height');
      gallery.style.height = '';
    }

    productSwiper = new Swiper(swiperSelector, {
      direction: 'horizontal',
      loop: false,
      slidesPerView: 1,
      touchStartPreventDefault: false,
      passiveListeners: true,
      threshold: 10,
      touchAngle: 25,
      resistanceRatio: 0.85,
      navigation: {
        nextEl: `.product-gallery__nav--next--${sectionId}`,
        prevEl: `.product-gallery__nav--prev--${sectionId}`
      }
    });
    window.productSwiper = productSwiper;

    if (savedActiveIndex > 0) {
      productSwiper.slideTo(savedActiveIndex, 0, false);
    }

    if (window.bindProductSwiperZoomEvents) {
      window.bindProductSwiperZoomEvents();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initSwiper());
  } else {
    initSwiper();
  }

  let resizeSwiperTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeSwiperTimer);
    resizeSwiperTimer = setTimeout(() => {
      const currentWidth = window.innerWidth;
      const wasDesktop = lastGalleryLayoutWidth >= DESKTOP_GALLERY_MIN_WIDTH;
      const isDesktop = currentWidth >= DESKTOP_GALLERY_MIN_WIDTH;

      if (wasDesktop !== isDesktop) {
        lastGalleryLayoutWidth = currentWidth;
        initSwiper();
      } else if (productSwiper) {
        productSwiper.update();
      }

      lastGalleryLayoutWidth = currentWidth;
      scheduleDesktopGalleryHeightUpdate();
    }, 200);
  });

  document.addEventListener('product-gallery:updated', scheduleDesktopGalleryHeightUpdate);
  document.addEventListener('product-gallery:updated', updateProductImageSkeletons);
  window.addEventListener('load', scheduleDesktopGalleryHeightUpdate);
  window.addEventListener('load', updateProductImageSkeletons);
  updateProductImageSkeletons();
  scheduleDesktopGalleryHeightUpdate();

  document.addEventListener('DOMContentLoaded', function () {
    const titleElement = document.querySelector(".product__title-price-container .product__title h1");
    if (titleElement) {
      const title = titleElement.textContent.toLowerCase();
      const titleCase = title
        .split(' ')
        .map(word => word.charAt(0).toLocaleUpperCase() + word.slice(1))
        .join(' ');
      titleElement.textContent = titleCase;
    }

    const productDataScript = document.getElementById('ProductRecentlyViewed-' + sectionId);
    if (productDataScript) {
      const productDetails = JSON.parse(productDataScript.textContent);
      let recentlyViewedProductsList = JSON.parse(localStorage.getItem('recentlyViewedProducts')) || [];

      let existingIndex = recentlyViewedProductsList.findIndex(function(item) {
        return item.handle === productDetails.handle;
      });

      if (existingIndex !== -1) {
        recentlyViewedProductsList.splice(existingIndex, 1);
      }

      recentlyViewedProductsList.unshift(productDetails);

      if (recentlyViewedProductsList.length > 4) {
        recentlyViewedProductsList = recentlyViewedProductsList.slice(0, 4);
      }

      localStorage.setItem('recentlyViewedProducts', JSON.stringify(recentlyViewedProductsList));
    }
  });

  let isLiberated = true;

  function handleizeOption(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function getImageUrl(imageItem) {
    if (!imageItem) return '';
    if (typeof imageItem === 'string') return imageItem;
    return imageItem.src || imageItem.url || imageItem.preview_image?.src || '';
  }

  function getSelectedColorImages(colorImagesMap, selectedColor) {
    const selectedColorHandle = handleizeOption(selectedColor);
    const directMatch = colorImagesMap[selectedColor] || colorImagesMap[selectedColorHandle];
    if (directMatch) return directMatch;

    const matchingKey = Object.keys(colorImagesMap).find(function(key) {
      return handleizeOption(key) === selectedColorHandle;
    });

    return matchingKey ? colorImagesMap[matchingKey] : null;
  }

  function getUniqueSlides(slides) {
    const slideKeys = new Set();

    return slides.filter(function(slide) {
      const image = slide.querySelector('img');
      const slideKey = image ? image.getAttribute('src') || image.getAttribute('data-src') || image.alt : slide.innerHTML;
      if (slideKeys.has(slideKey)) return false;
      slideKeys.add(slideKey);
      return true;
    });
  }

  window.changeSliderImages = function(selectedColor) {
    if (!isLiberated) return;

    const target = document.querySelector('.product__images__featured__image .swiper-wrapper');
    const template = document.querySelector('template.variant-images')?.content;
    if (!target || !template) return;

    isLiberated = false;

    const selectedColorHandle = handleizeOption(selectedColor);
    const matchingTemplateSlides = getUniqueSlides(
      Array.from(template.querySelectorAll('.swiper-slide')).filter(function(slide) {
        return handleizeOption(slide.getAttribute('data-variant')) === selectedColorHandle;
      })
    );

    if (matchingTemplateSlides.length) {
      target.innerHTML = '';
      matchingTemplateSlides.forEach(function(slide) {
        target.appendChild(slide.cloneNode(true));
      });
    } else {
      const productImagesContainer = document.querySelector('.product__images');
      const colorImagesData = productImagesContainer?.getAttribute('color-images');

      if (colorImagesData) {
        try {
          const cleanData = colorImagesData.replace(/&quot;/g, '"').replace(/&amp;/g, '&');
          const colorToImagesMap = JSON.parse(cleanData);
          const selectedColorImages = getSelectedColorImages(colorToImagesMap, selectedColor);
          const firstTemplateImage = template.querySelector('.swiper-slide');

          if (firstTemplateImage && Array.isArray(selectedColorImages) && selectedColorImages.length) {
            target.innerHTML = '';
            selectedColorImages.forEach(function(imageItem) {
              const imageUrl = getImageUrl(imageItem);
              if (!imageUrl) return;

              const clonedSlide = firstTemplateImage.cloneNode(true);
              const img = clonedSlide.querySelector('img');
              if (img) {
                img.src = imageUrl;
                img.srcset = `${imageUrl} 165w, ${imageUrl} 360w, ${imageUrl} 533w, ${imageUrl} 720w, ${imageUrl} 940w, ${imageUrl} 1066w, ${imageUrl} 1200w`;
              }
              target.appendChild(clonedSlide);
            });
          }
        } catch (error) {
          console.error('Erro ao processar metafields:', error);
        }
      }
    }

    const pagination = document.querySelector('custom-swiper-pagination');
    if (pagination && target) {
      const urls = [...target.querySelectorAll('.swiper-slide img')]
        .map((img) => img.currentSrc || img.src)
        .filter(Boolean);
      pagination.setAttribute('data-image-list', JSON.stringify(urls));
    }

    if (productSwiper) {
      productSwiper.update();
      productSwiper.slideTo(0);
    } else {
      target.style.transform = '';
    }

    const gallery = document.querySelector('.swiper__product-images');
    if (gallery) gallery.scrollTo({ top: 0, behavior: 'auto' });

    scheduleDesktopGalleryHeightUpdate();
    document.dispatchEvent(new CustomEvent('product-gallery:updated'));
    setTimeout(() => { isLiberated = true; }, 100);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('variant-selects [data-color-option] input[type="radio"]').forEach(function(input) {
      input.addEventListener('change', function(event) {
        if (event.target.checked) {
          window.changeSliderImages(event.target.value);
        }
      });
    });

    function getSelectedColorFromVariantPicker() {
      const checkedColorInput = document.querySelector('variant-selects [data-color-option] input[type="radio"]:checked');
      if (checkedColorInput?.value) {
        return checkedColorInput.value;
      }

      const urlParams = new URLSearchParams(window.location.search);
      const variantId = urlParams.get('variant');
      if (!variantId) return null;

      const variantsScript = document.querySelector('variant-selects script[type="application/json"]');
      if (!variantsScript) return null;

      try {
        const variants = JSON.parse(variantsScript.textContent);
        const variant = variants.find(function(item) {
          return String(item.id) === String(variantId);
        });
        if (!variant) return null;

        const variantSelectsEl = document.querySelector('variant-selects');
        const colorPosition = variantSelectsEl?.dataset.colorOptionPosition || '1';

        if (colorPosition === '2') return variant.option2;
        if (colorPosition === '3') return variant.option3;
        return variant.option1;
      } catch (error) {
        return null;
      }
    }

    function syncInitialGalleryImages() {
      const selectedColor = getSelectedColorFromVariantPicker();
      if (selectedColor) {
        window.changeSliderImages(selectedColor);
      }
    }

    syncInitialGalleryImages();
  });
})();
